<!--  -->
<template>
  <div>
    <div class="item">
      <span class="title">选择部门：</span>
      <div>
        <el-tag v-if="department_id!=''" style="margin-right: 10px;">{{ department_name }}</el-tag>
        <el-button type="primary" @click="choosebumen">选择部门</el-button>
      </div>
    </div>
    <div class="item">
      <span class="title">选择投手：</span>
      <div>
        <el-tag v-if="department_id!=''" style="margin-right: 10px;">{{ pitcher_name }}（{{ pitcher_id }}）</el-tag>
        <el-button type="primary" :disabled="department_id==''" @click="choosebuadwr">选择投手</el-button>
      </div>
    </div>
    <div class="item">
      <span class="title">巨量广告：</span>
      <div>
        <el-input
          v-model="multipleSub2"
          style="width:300px"
          placeholder="请输入多个的名字"
          @input="($event)=>{multipleSub2= handleParams($event)}"
        />
        <el-button type="primary" style="margin-left:10px" @click="multipleSubAdvertiser(2)">选中多个</el-button>
        <el-button type="success" style="margin-left:10px" @click="openFileUpload">一键导入</el-button>
        <input
          ref="fileInput"
          type="file"
          accept=".xlsx,.xls"
          style="display: none"
          @change="handleFileUpload"
        >
      </div>
    </div>
    <div class="checkBox" style="margin-top: 10px;margin-bottom: 10px;max-height: 500px;overflow-y: auto;">
      <span class="checkBox_title">选中的巨量广告</span>
      <div class="checkBox_content">
        <el-tag
          v-for="item in oceanAdObj"
          :key="item.value"
          class="content_item"
          style="margin: 5px;"
          size="small"
        >{{ item.label }}
          <i
            class="el-icon-close"
            style="font-size: 18px;"
            @click="deleteoceanAd(item)"
          />
        </el-tag>
      </div>
    </div>
    <div class="item">
      <span class="title">开始结束时间：</span>
      <div>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 300px;"
          @change="handleDateChange"
        />
        <el-button type="warning" style="margin-left: 20px;" @click="longterm">长期</el-button>
      </div>
    </div>
    <div class="item">
      <el-button type="primary" @click="sumbirter">确定</el-button>
    </div>

    <el-dialog
      title="部门"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :append-to-body="true"
      width="40%"
    >
      <admindialog ref="admindialogview" @callback="callback" />
    </el-dialog>

    <el-dialog
      title="投手"
      :visible.sync="dialogVisibletwo"
      :destroy-on-close="true"
      :append-to-body="true"
      width="40%"
    >
      <accoudialog ref="admindialogviewtwo" @callbacktwo="callbacktwo" />
    </el-dialog>
  </div>
</template>

<script>
import { getAdvertiser } from '@/api/shortPlayReport.js'
import admindialog from './admindialog.vue'
import accoudialog from './accoudialog.vue'
import { bindRelationcreateNative, bindRelationupdateNative, exportAdvertiserListNative } from '@/api/TKreleaseGroup.js'
export default {
  components: { admindialog, accoudialog },
  data() {
    return {
      type: null,

      department_id: '',
      department_name: '',
      pitcher_name: '',
      pitcher_id: '',
      start_date: '',
      end_date: '',
      dateRange: [],

      multipleSub2: null, // 输入的多个巨量的名字
      oceanAdValue: [], // 巨量值接口请求提交参数
      fromoOceanAd: [], // 巨量
      oceanAdObj: [], // 巨量tag列表

      dialogVisible: false,
      dialogVisibletwo: false,

      drawerItem: {},
      ids: null,
      uploadLoading: false

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(type, item) {
      this.type = type
      // eslint-disable-next-line eqeqeq
      if (type == 2) {
        console.log('item', item)
        this.department_name = item.department_name
        this.department_id = item.department_id
        this.pitcher_name = item.pitcher_name
        this.pitcher_id = item.pitcher_id
        this.start_date = item.start_date
        this.end_date = item.end_date
        this.dateRange = [item.start_date, item.end_date]
        this.drawerItem = item
        this.ids = item.id
        // 巨量广告
        // 巨量广告
        this.oceanAdValue = (this.drawerItem.ocean_advertiser_ids && this.drawerItem.ocean_advertiser_ids.length) ? this.drawerItem.ocean_advertiser_ids.map(id => String(id)) : []
        this.fromoOceanAd = this.oceanAdValue.length ? this.drawerItem.ocean_advertisers.map((item, index) => {
          return {
            value: String(item.account_id), // 强制转换为字符串
            label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
          }
        }) : []
        this.oceanAdObj = this.oceanAdValue.length ? this.drawerItem.ocean_advertisers.map((item, index) => {
          return {
            value: String(item.account_id), // 强制转换为字符串
            label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
          }
        }) : []
      }
    },
    handleParams(value) {
      var arr = ''
      const str = /[`~!@#$%^&*()_\ +=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*——\ +={}|《》？："”【】、；''，。、 ]/img
      arr = value.replace(str, ',')

      const str1 = /(,){1,}/img
      arr = arr.replace(str1, ',')
      return arr
    },
    // 选中多个广告主或者巨量
    async multipleSubAdvertiser(type) {
      if (type === 1) {
        if (!this.multipleSub1) {
          this.$message({
            message: '必须输入广告主 id 或 名字',
            type: 'warning'
          })
          return
        }
      } else {
        if (!this.multipleSub2) {
          this.$message({
            message: '必须输入巨量广告 id 或 名字',
            type: 'warning'
          })
          return
        }
      }
      const data = await getAdvertiser({ name: type === 1 ? this.multipleSub1 : this.multipleSub2, type: type })
      if (!data.data.list.length) {
        this.$message({
          message: '筛选为0个，没法选中',
          type: 'warning'
        })
      }
      let news = data.data.list.map((item) => {
        return {
          value: type === 2 ? String(item.account_id) : item.account_id, // 巨量广告强制转换为字符串
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      })
      if (type === 1) {
        // 广告主模块
        this.fromAdvertiser = news
        for (let i = 0; i < news.length; i++) {
          (this.advertiserValue.indexOf(news[i].value) < 0) && this.advertiserValue.push(news[i].value)
        }
        news = news.map(im => im.value)
        for (let i = 0; i < this.advertiserValue.length; i++) {
          news.indexOf(this.advertiserValue[i]) < 0 && news.push(this.advertiserValue[i])
        }
        this.change1(news)
        data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub1, data.data.list, 'account_id')
        this.multipleSub1 = null
      } else {
        // 巨量广告模块
        this.fromoOceanAd = news
        for (let i = 0; i < news.length; i++) {
          (this.oceanAdValue.indexOf(news[i].value) < 0) && this.oceanAdValue.push(news[i].value)
        }
        news = news.map(im => im.value)
        for (let i = 0; i < this.oceanAdValue.length; i++) {
          news.indexOf(String(this.oceanAdValue[i])) < 0 && news.push(String(this.oceanAdValue[i]))
        }
        this.change2(news)
        data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub2, data.data.list, 'account_id')
        this.multipleSub2 = null
      }
    },
    // 删除巨量
    deleteoceanAd(item) {
      this.oceanAdObj.splice(this.oceanAdObj.findIndex(im => String(im.value) === String(item.value)), 1)
      this.oceanAdValue.splice(this.oceanAdValue.indexOf(String(item.value)), 1)
    },
    // 选择巨量
    change2(item) {
      for (let i = 0; i < this.oceanAdValue.length; i++) {
        const im = String(this.oceanAdValue[i]) // 统一转换为字符串
        const index = this.oceanAdObj.findIndex(itemm => String(itemm.value) === im)
        index < 0 && this.oceanAdObj.push({ value: im, label: this.fromoOceanAd[this.fromoOceanAd.findIndex(itemm => String(itemm.value) === im)].label })
      }
      this.oceanAdObj = this.oceanAdObj.filter((imm) => {
        return !(item.indexOf(String(imm.value)) < 0)
      })
    },
    // 判断那个没选中
    judgeThatOneIsNotSelected(texts, arr, idName) {
      const testsr = texts.split(',')
      const unchecked = []
      testsr.forEach((text) => {
        let bool = true
        for (let i = 0; i < arr.length; i++) {
          if (String(arr[i][idName]) === String(text) || String(arr[i].account_name) === String(text)) {
            bool = false
            break
          }
        }
        bool && unchecked.push(text)
      })

      unchecked.length && this.$message({
        message: unchecked.join() + '  没被选中',
        type: 'warning'
      })
    },

    handleDateChange(val) {
      if (val && val.length === 2) {
        this.start_date = val[0]
        this.end_date = val[1]
      } else {
        this.start_date = ''
        this.end_date = ''
      }
      console.log('开始时间:', this.start_date, '结束时间:', this.end_date)
    },

    sumbirter() {
      // eslint-disable-next-line eqeqeq
      if (this.department_id == '') {
        this.$message.error('请选择部门')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.pitcher_id == '') {
        this.$message.error('请选择投手')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.start_date == '') {
        this.$message.error('请选择开始时间')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.oceanAdValue.length == 0) {
        this.$message.error('请选择巨量广告')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.end_date == '') {
        this.$message.error('请选择结束时间')
        return
      }
      console.log(this.type)
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        bindRelationcreateNative({
          department_id: this.department_id,
          pitcher_id: this.pitcher_id,
          start_date: this.start_date,
          end_date: this.end_date,
          ocean_advertiser_ids: this.oceanAdValue
        }).then((res) => {
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.$emit('updatawe')
        })
      } else {
        bindRelationupdateNative({
          department_id: this.department_id,
          pitcher_id: this.pitcher_id,
          start_date: this.start_date,
          end_date: this.end_date,
          ocean_advertiser_ids: this.oceanAdValue,
          id: this.ids
        }).then((res) => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$emit('updatawe')
        })
      }
    },
    choosebumen() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.admindialogview.send()
      })
    },
    callback(item) {
      this.dialogVisible = false
      this.department_name = item.name
      this.department_id = item.id
      console.log(item)
    },
    choosebuadwr() {
      this.dialogVisibletwo = true
      this.$nextTick(() => {
        this.$refs.admindialogviewtwo.send(this.department_id)
      })
    },
    callbacktwo(item) {
      this.dialogVisibletwo = false
      this.pitcher_name = item.admin_name
      this.pitcher_id = item.id
      console.log(item)
    },
    longterm() {
      // 获取今天日期并格式化为 YYYY-MM-DD
      const today = new Date().toISOString().split('T')[0]
      if (this.dateRange.length === 0) {
        // 初始为空：开始为今天，结束为 2099-01-01
        this.dateRange = [today, '2099-01-01']
        this.start_date = today
        this.end_date = '2099-01-01'
      } else {
        // 已有开始时间：保持开始时间，结束替换为 2099-01-01
        this.dateRange = [this.dateRange[0], '2099-01-01']
        this.end_date = '2099-01-01'
      }
    },
    // 打开文件上传器
    openFileUpload() {
      this.$refs.fileInput.click()
    },
    // 处理文件上传
    async handleFileUpload(e) {
      const file = e.target.files[0]
      if (!file) {
        return
      }

      // 验证文件类型
      const fileName = file.name
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
      const allowedExtensions = ['xlsx', 'xls']

      if (!allowedExtensions.includes(fileExtension)) {
        this.$message({
          message: '只能上传 Excel 文件（.xlsx 或 .xls）',
          type: 'error'
        })
        // 清空文件选择
        e.target.value = ''
        return
      }

      // 创建 FormData
      const formData = new FormData()
      formData.append('advertiser_file', file)

      this.uploadLoading = true
      try {
        const res = await exportAdvertiserListNative(formData)
        // 按照"选中多个"的逻辑处理返回的数据
        if (res && res.data && res.data.list && res.data.list.length) {
          // 将返回的数据转换为和"选中多个"一样的格式
          let news = res.data.list.map((item) => {
            return {
              value: String(item.account_id), // 强制转换为字符串
              label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
            }
          })

          // 巨量广告模块 - 按照 multipleSubAdvertiser 的逻辑处理
          this.fromoOceanAd = news
          for (let i = 0; i < news.length; i++) {
            (this.oceanAdValue.indexOf(news[i].value) < 0) && this.oceanAdValue.push(news[i].value)
          }
          news = news.map(im => im.value)
          for (let i = 0; i < this.oceanAdValue.length; i++) {
            news.indexOf(String(this.oceanAdValue[i])) < 0 && news.push(String(this.oceanAdValue[i]))
          }
          this.change2(news)

          this.$message({
            message: `文件上传成功，已选中 ${res.data.list.length} 个巨量广告`,
            type: 'success'
          })
        } else {
          this.$message({
            message: '文件上传成功，但未找到可用的数据',
            type: 'warning'
          })
        }
      } catch (error) {
        console.error('文件上传失败:', error)
        this.$message({
          message: error.message || '文件上传失败',
          type: 'error'
        })
      } finally {
        this.uploadLoading = false
        // 清空文件选择，以便可以重复选择同一文件
        // eslint-disable-next-line require-atomic-updates
        e.target.value = ''
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.item{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
</style>

